const transRarity = {
  0: 'normal',
  1: 'rare',
  2: 'superRare',
  3: 'ultraRare',
};

const deliveryStatus = {
  0: '対象外',
  1: '未発送',
  2: '発送済み',
};

export {
  transRarity,
  deliveryStatus,
};
